export default {"src":"/_next/static/media/bg_standart_4.0211a4e3.svg","height":209,"width":8,"blurWidth":0,"blurHeight":0};